export enum SkillType {
  CAN = 'can',
  MUST = 'must',
}
